// pages/CreateLooseDiamond.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import LooseDiamondForm from "../components/looseDiamond/LooseDiamondForm";

const CreateLooseDiamond = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 26 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="max-w-8xl mx-auto"
    >
      <div className="bg-white shadow-lg rounded-2xl border p-2">
        <LooseDiamondForm />
      </div>
    </motion.div>
  );
};

export default CreateLooseDiamond;
